<template>
  <div>
    <h1>Listagem de regiões prazo entrega</h1>
    <app-prazo-entrega-paises></app-prazo-entrega-paises>
    <app-prazo-entrega-regioes-pais></app-prazo-entrega-regioes-pais>
    <app-prazo-entrega-estados></app-prazo-entrega-estados>
    <app-prazo-entrega-regioes-estado></app-prazo-entrega-regioes-estado>
    <app-prazo-entrega-municipios></app-prazo-entrega-municipios>
  </div>
</template>

<script>
import PrazoEntregaEstados from "./PrazoEntregaEstados.vue";
import PrazoEntregaMunicipios from "./PrazoEntregaMunicipios.vue";
import PrazoEntregaRegioesEstado from "./PrazoEntregaRegioesEstado.vue";
import PrazoEntregaRegioesPais from "./PrazoEntregaRegioesPais.vue";
import PrazoEntregaPaises from "./PrazoEntregaPaises.vue";

export default {
  name: "Edit",
  components: {
    'app-prazo-entrega-estados': PrazoEntregaEstados,
    'app-prazo-entrega-municipios': PrazoEntregaMunicipios,
    'app-prazo-entrega-regioes-estado': PrazoEntregaRegioesEstado,
    'app-prazo-entrega-regioes-pais': PrazoEntregaRegioesPais,
    'app-prazo-entrega-paises': PrazoEntregaPaises,
  },
  data: function() {
    return {
    };
  },
  created: function() {
  },
  methods: {
  }
};
</script>

